export default __webpack_public_path__ + "static/media/threads_wordmark.a8621171.png";